import React, { useState } from "react";

function FaqPage() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqData = [
	{
	  question: "What is Digi Labour Solutions?",
	  answer:
		"Digi Labour Solutions is a service platform that helps customers find trusted labour and care services such as baby caretakers, elder caretakers, maids, drivers, and other household support staff.",
	},
	{
	  question: "How can I book a service?",
	  answer:
		"You can book a service by selecting the required category on the platform, filling in your requirement details, and submitting the form. Our team will review your request and connect you with suitable labour options.",
	},
	{
	  question: "How do I register as a labour or worker?",
	  answer:
		"Workers can register by visiting the labour registration section, filling in personal and work details, uploading required documents, and submitting the form for verification.",
	},
	{
	  question: "Is there any support for payment or booking issues?",
	  answer:
		"Yes. If you face booking issues, payment problems, or service-related concerns, you can contact our customer support team through the contact form, support email, or phone number provided on the website.",
	},
	{
	  question: "How are workers verified?",
	  answer:
		"Workers may be asked to submit identity proof, contact details, skill-related information, and other supporting documents during registration. Verification depends on the service category and onboarding process.",
	},
	{
	  question: "Can I contact support for labour profile updates?",
	  answer:
		"Yes. Registered labourers can reach out to the labour support team for profile updates, registration assistance, and login-related help.",
	},
	{
	  question: "Which cities and areas are currently supported?",
	  answer:
		"Supported cities and areas depend on your current service configuration in the platform. Customers can choose their city and area while posting a requirement or searching for available labour.",
	},
	{
	  question: "How long does it take to get a response after submitting a query?",
	  answer:
		"Response time may vary depending on the type of request, but the support team generally reviews new queries as quickly as possible and gets back through phone or email.",
	},
  ];

  const supportInfo = {
	customerSupport: {
	  title: "Customer Support",
	  description:
		"For service booking help, customer issues, payment support, or general platform queries.",
	  email: "customer_support@digilaboursolutions.com",
	  phone: "+91-8080808080",
	},
	labourSupport: {
	  title: "Labour Registration",
	  description:
		"For worker onboarding, profile registration, labour login help, and job-related assistance.",
	  email: "hr@digilaboursolutions.com",
	  phone: "+91-9090909080",
	},
  };

  const toggleFaq = (index) => {
	setOpenIndex((prev) => (prev === index ? null : index));
  };

  const styles = {
	page: {
	  minHeight: "100vh",
	  background: "linear-gradient(180deg, #f8fbff 0%, #eef4ff 100%)",
	  padding: "40px 16px",
	  fontFamily: '"Poppins", "Segoe UI", sans-serif',
	},

	container: {
	  maxWidth: "1180px",
	  margin: "0 auto",
	},

	hero: {
	  textAlign: "center",
	  marginBottom: "28px",
	},

	badge: {
	  display: "inline-block",
	  padding: "8px 14px",
	  borderRadius: "999px",
	  backgroundColor: "#e8f0ff",
	  color: "#0d6efd",
	  fontSize: "13px",
	  fontWeight: 700,
	  marginBottom: "12px",
	},

	title: {
	  margin: "0 0 10px 0",
	  fontSize: "32px",
	  fontWeight: 800,
	  color: "#0f172a",
	  lineHeight: 1.2,
	},

	subtitle: {
	  margin: "0 auto",
	  maxWidth: "760px",
	  fontSize: "15px",
	  lineHeight: 1.7,
	  color: "#475569",
	},

	layout: {
	  display: "grid",
	  gridTemplateColumns: "1.2fr 0.8fr",
	  gap: "24px",
	  alignItems: "start",
	},

	leftCard: {
	  backgroundColor: "#ffffff",
	  borderRadius: "22px",
	  padding: "28px",
	  boxShadow: "0 18px 45px rgba(15, 23, 42, 0.08)",
	  border: "1px solid rgba(15, 23, 42, 0.06)",
	},

	rightWrap: {
	  display: "flex",
	  flexDirection: "column",
	  gap: "20px",
	},

	infoCard: {
	  backgroundColor: "#ffffff",
	  borderRadius: "22px",
	  padding: "22px",
	  boxShadow: "0 18px 45px rgba(15, 23, 42, 0.08)",
	  border: "1px solid rgba(15, 23, 42, 0.06)",
	},

	quickHelpCard: {
	  background: "linear-gradient(135deg, #0f172a, #1e3a8a)",
	  color: "#ffffff",
	  borderRadius: "22px",
	  padding: "22px",
	  boxShadow: "0 18px 45px rgba(15, 23, 42, 0.14)",
	},

	sectionTitle: {
	  margin: "0 0 8px 0",
	  fontSize: "22px",
	  fontWeight: 700,
	  color: "#0f172a",
	},

	sectionText: {
	  margin: "0 0 22px 0",
	  fontSize: "14px",
	  color: "#64748b",
	  lineHeight: 1.7,
	},

	faqList: {
	  display: "flex",
	  flexDirection: "column",
	  gap: "14px",
	},

	faqItem: {
	  border: "1px solid #e2e8f0",
	  borderRadius: "18px",
	  backgroundColor: "#f8fbff",
	  overflow: "hidden",
	  transition: "all 0.3s ease",
	},

	faqButton: {
	  width: "100%",
	  border: "none",
	  background: "transparent",
	  padding: "18px 20px",
	  display: "flex",
	  alignItems: "center",
	  justifyContent: "space-between",
	  textAlign: "left",
	  cursor: "pointer",
	},

	faqQuestion: {
	  margin: 0,
	  fontSize: "15px",
	  fontWeight: 700,
	  color: "#0f172a",
	  lineHeight: 1.6,
	  paddingRight: "12px",
	},

	faqIcon: {
	  minWidth: "32px",
	  height: "32px",
	  borderRadius: "999px",
	  display: "flex",
	  alignItems: "center",
	  justifyContent: "center",
	  backgroundColor: "#e8f0ff",
	  color: "#0d6efd",
	  fontSize: "18px",
	  fontWeight: 700,
	},

	faqAnswerWrap: {
	  padding: "0 20px 18px 20px",
	  borderTop: "1px solid #e2e8f0",
	  backgroundColor: "#ffffff",
	},

	faqAnswer: {
	  margin: "14px 0 0 0",
	  fontSize: "14px",
	  lineHeight: 1.8,
	  color: "#475569",
	},

	infoHeader: {
	  margin: "0 0 14px 0",
	  fontSize: "20px",
	  fontWeight: 700,
	  color: "#0f172a",
	},

	infoDescription: {
	  margin: "0 0 18px 0",
	  fontSize: "14px",
	  lineHeight: 1.7,
	  color: "#64748b",
	},

	contactItem: {
	  marginBottom: "12px",
	  fontSize: "14px",
	  lineHeight: 1.7,
	  color: "#334155",
	  wordBreak: "break-word",
	},

	contactLabel: {
	  fontWeight: 700,
	  color: "#0f172a",
	  marginRight: "6px",
	},

	link: {
	  color: "#0d6efd",
	  textDecoration: "none",
	  fontWeight: 600,
	},

	quickHelpTitle: {
	  margin: "0 0 10px 0",
	  fontSize: "20px",
	  fontWeight: 700,
	},

	quickHelpText: {
	  margin: "0 0 16px 0",
	  fontSize: "14px",
	  lineHeight: 1.7,
	  color: "rgba(255,255,255,0.84)",
	},

	quickHelpList: {
	  paddingLeft: "18px",
	  margin: 0,
	  fontSize: "14px",
	  lineHeight: 1.8,
	  color: "#ffffff",
	},
  };

  const isMobile = typeof window !== "undefined" && window.innerWidth <= 900;

  return (
	<div style={styles.page}>
	  <div style={styles.container}>
		<div style={styles.hero}>
		  <span style={styles.badge}>Help Center</span>
		  <h1 style={styles.title}>Frequently Asked Questions</h1>
		  <p style={styles.subtitle}>
			Find answers to common questions about booking services, labour
			registration, customer support, and how Digi Labour Solutions works.
		  </p>
		</div>

		<div
		  style={{
			...styles.layout,
			gridTemplateColumns: isMobile ? "1fr" : "1.2fr 0.8fr",
		  }}
		>
		  <div style={styles.leftCard}>
			<h2 style={styles.sectionTitle}>Common Questions</h2>
			<p style={styles.sectionText}>
			  Browse the frequently asked questions below to quickly find answers
			  related to services, support, and worker registration.
			</p>

			<div style={styles.faqList}>
			  {faqData.map((item, index) => {
				const isOpen = openIndex === index;

				return (
				  <div
					key={index}
					style={{
					  ...styles.faqItem,
					  boxShadow: isOpen
						? "0 12px 28px rgba(13, 110, 253, 0.08)"
						: "none",
					}}
				  >
					<button
					  type="button"
					  onClick={() => toggleFaq(index)}
					  style={styles.faqButton}
					  aria-expanded={isOpen}
					>
					  <h3 style={styles.faqQuestion}>{item.question}</h3>
					  <span style={styles.faqIcon}>{isOpen ? "−" : "+"}</span>
					</button>

					{isOpen && (
					  <div style={styles.faqAnswerWrap}>
						<p style={styles.faqAnswer}>{item.answer}</p>
					  </div>
					)}
				  </div>
				);
			  })}
			</div>
		  </div>

		  <div style={styles.rightWrap}>
			<div style={styles.infoCard}>
			  <h3 style={styles.infoHeader}>{supportInfo.customerSupport.title}</h3>
			  <p style={styles.infoDescription}>
				{supportInfo.customerSupport.description}
			  </p>
			  <p style={styles.contactItem}>
				<span style={styles.contactLabel}>Email:</span>
				<a
				  href={`mailto:${supportInfo.customerSupport.email}`}
				  style={styles.link}
				>
				  {supportInfo.customerSupport.email}
				</a>
			  </p>
			  <p style={styles.contactItem}>
				<span style={styles.contactLabel}>Phone:</span>
				<a
				  href={`tel:${supportInfo.customerSupport.phone.replace(/\s+/g, "")}`}
				  style={styles.link}
				>
				  {supportInfo.customerSupport.phone}
				</a>
			  </p>
			</div>

			<div style={styles.infoCard}>
			  <h3 style={styles.infoHeader}>{supportInfo.labourSupport.title}</h3>
			  <p style={styles.infoDescription}>
				{supportInfo.labourSupport.description}
			  </p>
			  <p style={styles.contactItem}>
				<span style={styles.contactLabel}>Email:</span>
				<a
				  href={`mailto:${supportInfo.labourSupport.email}`}
				  style={styles.link}
				>
				  {supportInfo.labourSupport.email}
				</a>
			  </p>
			  <p style={styles.contactItem}>
				<span style={styles.contactLabel}>Phone:</span>
				<a
				  href={`tel:${supportInfo.labourSupport.phone.replace(/\s+/g, "")}`}
				  style={styles.link}
				>
				  {supportInfo.labourSupport.phone}
				</a>
			  </p>
			</div>

			<div style={styles.quickHelpCard}>
			  <h3 style={styles.quickHelpTitle}>Quick Help</h3>
			  <p style={styles.quickHelpText}>
				Check these answers first before raising a support request. For
				detailed issues, contact the support team directly.
			  </p>
			  <ul style={styles.quickHelpList}>
				<li>Booking and service questions</li>
				<li>Support and complaint help</li>
				<li>Labour registration guidance</li>
				<li>Profile and account assistance</li>
			  </ul>
			</div>
		  </div>
		</div>
	  </div>
	</div>
  );
}

export default FaqPage;